module.exports = __webpack_public_path__ + "img/bjhlwfy_position_img.198b6994.png";